import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import {
  Button,
} from './Styles';
import Header from '../../Common/Header';
import { Cab, User } from '../../../../lib/types';
import { getFoodifoxDataLazy } from '../../../../lib/axios/FoodifoxDataAPI';
import { getCabId32Str, getWindowWidth, isMobile } from '../../../../lib/utils/utils';
import { Australia } from '../../../../assets/Base64Image';
import Location from '../../Common/Location';
import ColumnCenter from '../../../../components/Layout/ColumnCenter/ColumnCenter';
import RowBetween from '../../../../components/Layout/RowBetween';
import RowCenter from '../../../../components/Layout/RowCenter';
import InterMediumText from '../../../../components/Text/InterMediumText';
import PingFangMediumText from '../../../../components/Text/PingFangMediumText';
import InterBoldText from '../../../../components/Text/InterBoldText';
import InterRegularText from '../../../../components/Text/InterRegularText';
import Input from '../../../../components/Input';
import SMSCode from '../../Common/SMSCode';
import InterMediumItalicText from '../../../../components/Text/InterMediumItalicText';
import TermsConditionsModal from '../../Common/TermsConditionsModal';
import InterItalicText from '../../../../components/Text/InterItalicText';
import Column from '../../../../components/Layout/Column';
import Loading from '../../../../components/Loading';

const CheckPhone: FC<Props> = ({
  isEnglish,
  setIsEnglish,
  cab,
  setPhoneNumber,
  onClose,
  setShowAi,
}) => {
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [phoneCheck, setPhoneCheck] = useState<boolean>();
  const [checkPhoneValid, { loading: checkPhoneLoading }] = getFoodifoxDataLazy('/foxH5Phone/checkPhoneValid');
  const [sendVerifyCodeLazy, { loading: sendVerifyCodeLoading }] = getFoodifoxDataLazy<string>('/foxH5Phone/sendVerifyCode');
  const [checkVerifyCodeLazy, { loading: checkVerifyCodeLoading }] = getFoodifoxDataLazy('/foxH5Phone/checkVerifyCode');

  const timeIntervalRef = useRef<NodeJS.Timer>();
  const timeWaitRef = useRef<number>();

  const [verifyPhone, setVerifyPhone] = useState<string>();
  const [verifyCode, setVerifyCode] = useState<string>();
  const [codeCheck, setCodeCheck] = useState<boolean>();
  const [timeWait, setTimeWait] = useState<string>();
  const [codeId, setCodeId] = useState<string>();
  const [showTermsModal, setShowTermsModal] = useState<boolean>(false);

  useEffect(() => {
    setShowLoading(checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading);

    return () => {
      setShowLoading(false);
    };
  }, [checkPhoneLoading, sendVerifyCodeLoading, checkVerifyCodeLoading]);

  useEffect(() => {
    timeIntervalRef.current = setInterval(() => {
      if (timeWaitRef.current != null && timeWaitRef.current <= 1) {
        timeWaitRef.current = undefined;
        setTimeWait(undefined);
        return;
      }
      if (timeWaitRef.current != null && timeWaitRef.current > 1) {
        timeWaitRef.current -= 1;
        setTimeWait(timeWaitRef.current.toFixed(0));
      }
    }, 1000);

    return () => {
      timeWaitRef.current = undefined;
      setTimeWait(undefined);
      if (timeIntervalRef.current != null) {
        clearInterval(timeIntervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    // 达到长度后自动触发验证验证码
    if (verifyCode != null && verifyCode.length >= 4) {
      checkVerifyCode();
    }
  }, [verifyCode]);

  /**
   * 发送验证码
   */
  const sendVerifyCode = () => {
    // 清空验证码
    setVerifyCode(undefined);

    // 倒计时没有结束时，不继续发送短信
    if (timeWaitRef.current != null && timeWaitRef.current > 0) {
      return;
    }
    if (verifyPhone == null || verifyPhone.trim().length < 9) {
      return;
    }

    // 验证手机号
    checkPhoneValid({
      param: {
        phoneNumber: verifyPhone,
        phoneCode: 'AU',
      },
      onError() {
        // 手机号码校验标识
        setPhoneCheck(false);
      },
      onCompleted() {
        // 发送验证码
        sendVerifyCodeLazy({
          param: {
            phoneNumber: verifyPhone,
            phoneCode: 'AU',
          },
          onCompleted(resultData) {
            // 倒计时秒数
            timeWaitRef.current = 60;
            setTimeWait('60');
            // 设置验证码ID，验证验证码时需要用到
            setCodeId(resultData);
            // 手机号码校验标识
            setPhoneCheck(true);
          },
        });
      },
    });
  };

  /**
   * 验证验证码
   */
  const checkVerifyCode = () => {
    if (verifyCode == null || verifyCode.trim().length < 4) {
      return;
    }
    if (verifyPhone == null || verifyPhone.trim().length < 9) {
      return;
    }

    checkVerifyCodeLazy({
      param: {
        id: codeId,
        code: verifyCode,
      },
      onError() {
        // 验证码校验标识
        setCodeCheck(false);
      },
      onCompleted() {
        // 验证码校验标识
        setCodeCheck(true);
      },
    });
  };

  return (
    <>
      {
        showTermsModal && (
          <TermsConditionsModal
            callback={() => {
              setShowTermsModal(false);
            }}
            showAgreeBtn={false}
            showExitBtn={false}
            isEnglish={isEnglish}
          />
        )
      }
      {
        showLoading && (
          <Loading />
        )
      }
      <Column style={{ alignItems: isMobile() ? undefined : 'center' }}>
        <div style={{ width: isMobile() ? undefined : 400 }}>
          {/* 头部 */}
          <Header
            onClose={onClose}
            showSupport={false}
            showFAQ={false}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            style={{ marginTop: '20px' }}
            cabId32Str={getCabId32Str(cab.cabId)}
          />

          {/* 地点 */}
          <Location isEnglish={isEnglish} cab={cab} width={isMobile() ? getWindowWidth() - 40 : 400} contentWidth={isMobile() ? getWindowWidth() - 60 : 400} style={{ marginTop: '25px' }} />

          {/* 提示验证手机号 */}
          <div style={{ width: isMobile() ? getWindowWidth() - 40 : 400, marginTop: 60, marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
            {
              isEnglish ? (
                <InterMediumText fontSize={16} lineHeight={22}>
                  Enter your mobile number<InterBoldText color={'#F44336'} fontSize={20} isSpan={true}>*</InterBoldText>
                </InterMediumText>
              ) : (
                <PingFangMediumText fontSize={16} color={'#000000'}>
                  输入您的手机号<InterBoldText color={'#F44336'} fontSize={20} isSpan={true}>*</InterBoldText>
                </PingFangMediumText>
              )
            }
          </div>

          {/* 验证电话号码 */}
          <RowBetween style={{ width: isMobile() ? getWindowWidth() - 40 : 400, height: 60, background: '#FFFFFF', margin: '8px auto 0 auto' }}>
            <RowCenter style={{ minWidth: 80, height: 60, backgroundColor: '#E4E4E4', borderRadius: 5 }}>
              <ColumnCenter style={{ height: '100%', alignItems: 'center' }}>
                <img src={Australia} style={{ width: '22px' }} />
              </ColumnCenter>
              <ColumnCenter style={{ height: '100%', marginLeft: '5px' }}>
                <InterRegularText fontSize={18}>
                  +61
                </InterRegularText>
              </ColumnCenter>
            </RowCenter>
            <ColumnCenter style={{ height: '100%', alignItems: 'center', width: '100%', backgroundColor: 'rgba(228, 228, 228, 0.5)', borderRadius: 5, marginLeft: 7 }}>
              {
                <Input
                  style={{
                    border: 'none',
                    outline: 'none',
                    fontSize: '18px',
                    fontFamily: 'Inter-Regular, Inter',
                    fontWeight: 400,
                    color: '#000000',
                    backgroundColor: 'transparent',
                    lineHeight: '35px',
                    textAlign: 'center',
                    width: '100%',
                  }}
                  autoFocus={true}
                  type="tel"
                  inputMode="numeric"
                  placeholder={'0400 000 000'}
                  placeFontFamily={'Inter-Regular, Inter'}
                  placeholderColor={'rgba(0, 0, 0, 0.5)'}
                  value={verifyPhone}
                  onChange={(e) => {
                    //去掉所有空格，重新设置文本款过的值
                    setVerifyPhone(e.target.value.replace(/\s*/g, ""));
                    setPhoneCheck(undefined);
                    setCodeCheck(undefined);
                  }}
                />
              }
            </ColumnCenter>
          </RowBetween>

          {/* 手机号验证提示 */}
          <InterItalicText fontSize={12} color={'#F44336'} lineHeight={20} marginTop={5} textAlign={'center'} opacity={phoneCheck === false ? 1 : 0}>
            Mobile number is invalid
          </InterItalicText>

          {/* 获取验证码按钮 */}
          <div>
            <Button
              disabled={checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || phoneCheck === false || timeWait != null || verifyPhone == null || verifyPhone.trim().length < 9}
              onClick={() => sendVerifyCode()}
              style={{ height: 60, background: (checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || phoneCheck === false || timeWait != null || verifyPhone == null || verifyPhone.trim().length < 9) ? '#E4E4E4' : '#00D2B9', border: 'none', borderRadius: 5, width: '60%', margin: '5px auto 0 auto', flexDirection: 'row', justifyContent: 'space-between' }}
            >
              <span style={{ fontSize: '16px', fontFamily: 'Squad-SemiBold, Squad', fontWeight: 600, color: '#FFFFFF', lineHeight: '22px', marginRight: '5px', opacity: 0 }}>
                {timeWait != null ? '(' + timeWait + 's)' : ''}
              </span>
              {
                isEnglish ? (
                  <InterMediumText fontSize={18} color={'#ffffff'}>
                    {timeWait ? 'Code sent' : 'Send code'}
                  </InterMediumText>
                ) : (
                  <PingFangMediumText fontSize={18} color={'#ffffff'}>
                    {timeWait ? '验证码已发送' : '发送验证码'}
                  </PingFangMediumText>
                )
              }
              <span style={{ fontSize: '16px', fontFamily: 'Squad-SemiBold, Squad', fontWeight: 600, color: '#FFFFFF', lineHeight: '22px', marginLeft: '5px' }}>
                {timeWait != null ? '(' + timeWait + ')' : ''}
              </span>
            </Button>
          </div>

          {/* 验证码 */}
          <div style={{ width: isMobile() ? getWindowWidth() - 40 : 400, marginTop: 40, marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
            {
              isEnglish ? (
                <InterMediumText fontSize={16} lineHeight={22}>
                  Enter 4-digit code sent via SMS<InterBoldText color={'#F44336'} fontSize={20} isSpan={true}>*</InterBoldText>
                </InterMediumText>
              ) : (
                <PingFangMediumText fontSize={16} color={'#000000'}>
                  输入收到的4位验证码<InterBoldText color={'#F44336'} fontSize={20} isSpan={true}>*</InterBoldText>
                </PingFangMediumText>
              )
            }
            <div style={{ marginTop: 5, width: 240, padding: '0 19px', marginLeft: 'auto', marginRight: 'auto' }}>
              <SMSCode
                style={{ marginTop: '10px' }}
                callback={(smsCode) => {
                  let code = smsCode.replace(/\s*/g, "");
                  if (code.length > 4) {
                    code = code.substring(0, 4);
                  }
                  setVerifyCode(code);
                  setCodeCheck(undefined);
                }}
              />
            </div>
          </div>

          {/* 验证码验证提示 */}
          {
            isEnglish ? (
              <InterItalicText fontSize={12} color={'#F44336'} lineHeight={20} marginTop={5} textAlign={'center'} opacity={codeCheck === false ? 1 : 0}>
                4-digit code is incorrect
              </InterItalicText>
            ) : (
              <InterItalicText fontSize={12} color={'#F44336'} lineHeight={20} marginTop={5} textAlign={'center'} opacity={codeCheck === false ? 1 : 0}>
                验证码错误
              </InterItalicText>
            )
          }

          {/* 验证验证码按钮 */}
          <div style={{ paddingBottom: '50px' }}>
            <Button
              disabled={checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || codeCheck === false || verifyPhone == null || verifyPhone.trim().length < 9 || verifyCode == null || verifyCode.trim().length < 4}
              onClick={() => {
                if (verifyPhone == null || verifyPhone.trim().length < 9) {
                  return;
                }
                setPhoneNumber(verifyPhone);
                setShowAi(true);
              }}
              style={{ height: 60, background: (checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || codeCheck === false || verifyPhone == null || verifyPhone.trim().length < 9 || verifyCode == null || verifyCode.trim().length < 4) ? '#E4E4E4' : '#00D2B9', border: 'none', borderRadius: 5, width: '60%', margin: '5px auto 0 auto' }}
            >
              {
                isEnglish ? (
                  <InterMediumText fontSize={18} color={'#ffffff'}>
                    Next
                  </InterMediumText>
                ) : (
                  <PingFangMediumText fontSize={18} color={'#ffffff'}>
                    下一步
                  </PingFangMediumText>
                )
              }
            </Button>
          </div>

          <RowCenter style={{ position: 'fixed', bottom: 0, paddingBottom: 10, paddingTop: 5, width: '100%', backgroundColor: '#FFFFFF' }}>
            <Button onClick={() => setShowTermsModal(true)}>
              <InterMediumItalicText fontSize={12} textDecorationLine={'underline'}>
                Terms of use and Privacy Policy
              </InterMediumItalicText>
            </Button>
          </RowCenter>
        </div>
      </Column>
    </>
  );
};

export interface Props {
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  cab: Cab;
  setPhoneNumber: (phoneNumber: string) => void;
  onClose: () => void;
  setShowAi: (show: boolean) => void;
}

export default CheckPhone;
